import * as React from 'react';

import './App.css';
import Home from './components/home.jsx';
//import AboutUs from './components/AboutUs.js';
import Finance from './components/finance.js';
import Governance from './components/governance.js';
import Estate from './components/estate.js';
import Chairman from './components/chairman.js';
import ContactUs from './components/contact-us.js';
import Hood from './components/conT.jsx';
import Team from './components/team.js';
import About from './components/aboutus.js';
import Abt from './components/Abt.js';
import Careers from './components/careers.js';
import Liquidity from './components/liquidity.js';
import Lending from './components/lending.js';
import Opportunistic from './components/opportunistic.js';
import ScrollToTop from "./ScrollToTop";


import { Routes, Route} from "react-router-dom";
//errors are due to js file extension
/* eslint no-unused-vars : "off" */
function App() {
/*logic lives here*/

  return (

        <div>
          <ScrollToTop />
          <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="opportunities" element={<Opportunistic />}></Route>
          <Route path="corporate-finance" element={<Finance />}></Route>
          <Route path="lending" element={<Lending />}></Route>
          <Route path="chairmans-message" element={<Chairman />}></Route>
          <Route path="corporate-governance" element={<Governance />}></Route>
          <Route path="estate" element={<Estate />}></Route>
          <Route path="about-us" element={<About />}></Route>
          <Route path="careers" element={<Careers />}></Route>
          <Route path="abt" element={<Abt />}></Route>
          <Route path="contact-us" element={<Hood />}></Route>
          <Route path="team" element={<Team />}></Route>
          <Route path="liquidity-solutions" element={<Liquidity />}></Route>


        </Routes>

        </div>

  );
}

export default App;
